import { useState } from "react";
import GModal from "../../design/components/GModal";
import { CustomInput } from "../../design/components/customComponents";
import Button from "../../design/Button";
import { useNavigate } from "react-router-dom";

const AddLicenseModal = ({ visible, handleClose, type, featureId = null }) => {
  const navigate = useNavigate();
  const [quantity, setQuantity] = useState({ value: null, error: null });

  const handleCloseModal = () => {
    setQuantity({ value: null, error: null });
    handleClose();
  };

  const handleNextBtn = () => {
    const payload = {
      quantity: quantity.value,
      type: type === "Viewer" ? "viewer" : "feature"
    };
    if(payload?.type === "feature"){
      payload["feature_id"] = featureId;
    }
    navigate("/billing/cart", { state: { payload } });
  };

  return (
    <GModal
      heading="Add license"
      visible={visible}
      closeModal={handleCloseModal}
      bottomButtons={[
        <Button
          styleOverride={btnStyle}
          hierarchy="white"
          variant="outlined"
          disabled={false}
          buttonText="Cancel"
          onClick={handleCloseModal}
        />,
        <Button
          styleOverride={btnStyle}
          hierarchy="green"
          buttonText="Next"
          onClick={handleNextBtn}
          disabled={!quantity.value || quantity.value <= 0}
        />,
      ]}
      modalStyle={{
        width: "470px",
      }}
      body={
        <>
          <CustomInput
            label="License"
            value={{ value: type, error: null }}
            handleChange={() => null}
            inputProps={{ disabled: true }}
          />
          <CustomInput
            placeholder="Enter quantity"
            label="Quantity"
            value={quantity}
            handleChange={(e) =>
              setQuantity((prev) => ({ ...prev, value: e.target.value }))
            }
            handleFocus={() =>
              setQuantity((prev) => ({ ...prev, error: null }))
            }
            name="license"
            type="number"
            inputProps={{ min: 1 }}
          />
        </>
      }
    />
  );
};

const btnStyle = {
  height: "36px",
  fontSize: "14px",
  lineHeight: "14px",
  fontWeight: "400",
  padding: "10px 16px",
};

export default AddLicenseModal;
